import React, {CSSProperties} from 'react';
import {SliderPhoto1, SliderPhoto2, SliderPhoto3} from "../Assets";
import {Swiper, SwiperSlide} from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import {Autoplay, Pagination, Navigation} from "swiper";

export default function SliderComponent() {
    return (
        <>
            <Swiper
                spaceBetween={30}
                centeredSlides={true}
                autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                }}
                pagination={{
                    clickable: true,
                }}
                navigation={true}
                modules={[Autoplay, Pagination, Navigation]}
                className="w-full"
                style={{
                    "--swiper-pagination-color": "#D6AD60",
                    "--swiper-navigation-color": "#D6AD60",
                } as CSSProperties}
            >
                <SwiperSlide>
                    <img
                        className="object-fill w-full h-2/3"
                        src={SliderPhoto1}
                        alt="image slide 1"
                    />
                </SwiperSlide>
                <SwiperSlide>
                    <img
                        className="object-fill w-full h-2/3"
                        src={SliderPhoto2}
                        alt="image slide 2"
                    />
                </SwiperSlide>
                <SwiperSlide>
                    <img
                        className="object-fill w-full h-2/3"
                        src={SliderPhoto3}
                        alt="image slide 3"
                    />
                </SwiperSlide>
            </Swiper>
        </>
    );
}